export const voucherTranslation = {
  fi: {
    Voucher: {
      voucher: 'Kuponki',
    },
  },
};
